import { UserRoleEnum } from 'enums'
import { useToken } from 'hooks'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { userSelectors } from 'slices/user.slice'
import { history } from 'utils'

const Home = () => {
  const { token } = useToken()
  const role = useSelector(userSelectors.selectRole)
  useEffect(() => {
    if (token) {
      if (role === UserRoleEnum.ADMIN) history.push('/admin/dashboard')
      else if ([UserRoleEnum.TENANT_ADMIN, UserRoleEnum.TENANT_USER].includes(role)) history.push('/tenant/dashboard')
    } else {
      history.push('/login')
    }
  }, [token, role])
  return null
}

export default Home
